import Messages from 'flow/pages/Messages';
import MessagesDrivePage from 'flow/pages/MessagesDrivePage';
import MessagesFilesPage from 'flow/pages/MessagesFilesPage';
import MessagesImagesPage from 'flow/pages/MessagesImagesPage';
import MessagesMembersPage from 'flow/pages/MessagesMembersPage';
import MessagesPostsPage from 'flow/pages/MessagesPostsPage';
import MessagesDetailsPage from 'flow/pages/messages/MessagesDetailsPage';
import Overview from 'flow/pages/messages/Overview';
import { routes } from 'flow/types/routes';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NewChatPage from '../pages/messages/NewChatPage';
import RedirectConferenceLobby from 'flow/route-components/redirect-conference-lobby';
import RedirectChatSession from 'flow/route-components/redirect-chat-session';
import ChatMeeting from 'flow/route-components/chat/ChatMeeting';
import ChatSessionContact from 'flow/route-components/ChatSessionContact';
import ChatSessionContactCalendar from 'flow/route-components/ChatSessionContactCalendar';
import LandingPageMeetings from 'flow/components/nav/landing-pages/LandingPageMeetings';
import PbxConference from 'flow/route-components/PbxConference';

const MessagesRoutes = () => {
    return (
        <Switch>
            <Route
                path={[
                    routes['messages.id.members.contact.key.calendar'],
                    routes['messages.id.contact.key.calendar'],
                    routes['messages.id.settings.members.contact.key.calendar'],
                    routes['messages.id.settings.contact.key.calendar'],
                ]}
                exact={true}
                component={ChatSessionContactCalendar}
            />
            <Route
                path={[
                    routes['messages.id.contact.key'],
                    routes['messages.id.members.contact.key'],
                    routes['messages.id.settings.members.contact.key'],
                    routes['messages.id.settings.contact.key'],
                ]}
                exact={true}
                component={ChatSessionContact}
            />

            <Route
                path={routes['messages.id.members']}
                component={MessagesMembersPage}
            />
            <Route
                path={routes['messages.id.files']}
                component={MessagesFilesPage}
            />
            <Route
                path={routes['messages.id.drive']}
                component={MessagesDrivePage}
            />
            <Route
                path={routes['messages.id.images']}
                component={MessagesImagesPage}
            />
            <Route
                path={routes['messages.id.posts']}
                component={MessagesPostsPage}
            />
            <Route
                path={routes['messages.id.settings']}
                component={MessagesDetailsPage}
            />
            <Route
                path={routes['messages.id.redirect']}
                component={RedirectChatSession}
            />
            <Route
                path={routes['messages.id.redirect.lobby']}
                component={RedirectConferenceLobby}
            />
            <Route path={routes['messages.id.lobby']} component={ChatMeeting} />
            <Route path={routes['messages.create']} component={NewChatPage} />
            <Route path={routes['messages.overview']} component={Overview} />
            <Route
                path={routes['messages.meetings']}
                component={LandingPageMeetings}
            />
            <Route
                path={routes['messages.conferences.entityKey']}
                component={PbxConference}
            />
            <Route path={routes['messages.id']} component={Messages} />
            <Route path={routes['messages']} component={Overview} />
        </Switch>
    );
};

export default MessagesRoutes;
